module.exports = __webpack_public_path__ + "static/img/A-android.f590713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-android.png
// module id = gsN1
// module chunks = 3